import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Import all litmus components
import { LitmusInputComponent } from './litmus-input/litmus-input.component';
import { LitmusAttatchmentComponent } from './litmus-attatchment/litmus-attatchment.component';
import { LitmusDropdownComponent } from './litmus-dropdown/litmus-dropdown.component';
import { LtmsDatetimePickerComponent } from './ltms-datetime-picker/ltms-datetime-picker.component';
import { LitmusSearchComponent } from './litmus-search/litmus-search.component';
import { LitmusLabelComponent } from './litmus-label/litmus-label.component';
import { LitmusSeperatorComponent } from './litmus-seperator/litmus-seperator.component';
import { LitmusButtonComponent } from './litmus-button/litmus-button.component';
import { LitmusHeaderComponent } from './litmus-header/litmus-header.component';
import { LitmusLinkComponent } from './litmus-link/litmus-link.component';
import { LitmusListViewerComponent } from './litmus-list-viewer/litmus-list-viewer.component';

@NgModule({
  declarations: [
    LitmusInputComponent,
    LitmusAttatchmentComponent,
    LitmusDropdownComponent,
    LtmsDatetimePickerComponent,
    LitmusSearchComponent,
    LitmusLabelComponent,
    LitmusSeperatorComponent,
    LitmusButtonComponent,
    LitmusHeaderComponent,
    LitmusLinkComponent,
    LitmusListViewerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    // Export LtmsDatetimePickerComponent so it can be used in other modules
    LtmsDatetimePickerComponent,
    // Export other components as well for consistency
    LitmusInputComponent,
    LitmusAttatchmentComponent,
    LitmusDropdownComponent,
    LitmusSearchComponent,
    LitmusLabelComponent,
    LitmusSeperatorComponent,
    LitmusButtonComponent,
    LitmusHeaderComponent,
    LitmusLinkComponent,
    LitmusListViewerComponent
  ]
})
export class LitmusComponentsModule { } 